/* eslint-disable */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Draft from '../../../components/Draft';
import DraftWysiwyg from '../../../components/DraftWysiwyg';
import React, { createContext, forwardRef, useState } from 'react';
import FileUpload from '../../../components/FileUpload';
import { useEffect } from 'react';
import { DatePicker, DatePickerRange } from '../../../components/DatePicker';
import RadioGroup from '../../../components/RadioGroup';
import moment from 'moment'
import DropDown from '../../../components/DropDown';
import { useContext } from 'react';
import { ConfigContext } from '../../../providers/ConfigProvider';

import IconCheck from '../../../components/IconCheck';
import PersonModal from '../../../components/PersonModal';
import Drawer from '../../../components/Drawer';
import { AuthContext } from '../../../providers/AuthProvider';
import UserPhoto from '../../../components/UserPhoto';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DomainContext } from '../../../providers/DomainProvider';
import FormBuilderProvider from '../../../components/FormBuilder';
import SubtaskProvider from '../../../components/Subtask';
import Input from '../../../components/Input';
import * as yup from 'yup';
import { useFormik } from 'formik';
import TaskRepetition from '../../../components/TaskRepetition';
import BoxLoading from '../../../components/BoxLoading';

const Context = createContext({
    form: {},
    subtasks: [],
    addSubTask: () => {},
    setForm: () => {},
    createTask: () => {},
})

const Provider = ({children}) => {
    const { apiCall } = useContext(AuthContext)
    const { notify } = useContext(ConfigContext)

    const [form, setForm] = useState({})
    const [subtasks, setSubtasks] = useState([])
    const [template, setTemplate] = useState(null)
    const [allReady, setAllReady] = useState(false)
    const [templateForms, setTemplateForms] = useState([])
    
    const navigate = useNavigate()

    const [searchParams] = useSearchParams();

    const loadTemplate = async (id) => {
        const { data } = await apiCall({
            action: 'get-domain-template-task',
            id: id
        })
        if(data.status === 1){
            setTemplate(data.data)
            setSubtasks(data.data.subtasks ? data.data.subtasks : [])
            setForm(data.data.form ? data.data.form : {})
            setAllReady(true)
        }
    }



    const getTemplateForms = async () => {
        const { data } = await apiCall({action: 'get-domain-template-forms'});
       
        if(data.status === 1){
            setTemplateForms(data.data)
        }
    }

    useEffect(() => {
        getTemplateForms()
    }, [])
    
    useEffect(() => {
        if(searchParams.get('mal')){
            loadTemplate(searchParams.get('mal'))
        }else{
            setAllReady(true)
        }
    }, [searchParams])

    return <Context.Provider value={{
        form,
        subtasks,
        template,
        templateForms,
        addSubTask: (task, index) => {
            if(index === -1){
                setSubtasks([...subtasks, task])
            }else{
                const newSubTasks = subtasks
                newSubTasks[index] = task
                setSubtasks(newSubTasks)
            }
        },
        setForm: (form) => {
            console.log('setting form', form)
            setForm(form)
        },
        createTask: async (task) => {
            
            const status = await apiCall({
                action: 'create-domain-task', 
                name: task.name,
                files: task.files,
                description: task.description,
                signature: task.signature,
                priority: task.priority,
                interval: task.interval,
                responsible: task.responsible,
                responsibleUsers: task.responsibleUsers,
                responsibleCompanies: task.responsibleCompanies,
                form: form ? form : null,
                subtasks: subtasks ? subtasks : null,
            })

            notify(status.data.status, 'Suksess!', status.data.message)

            if(status.data.status === 1){
                navigate(-1)
            }

        }
    }}>{allReady ? children : <BoxLoading />}</Context.Provider>
}


export default function DomainNewTask(){
    return (
        <Provider>
            <CreateTask />
        </Provider>
    )
}

function CreateTask(){
    const { form, subtasks, template, createTask } = useContext(Context)
    const { domainUsers, domainCompanies, reloadDomainCompanies } = useContext(DomainContext)

    const navigate = useNavigate()

    const [personModalOpen, setPersonModalOpen] = useState(false)
    const [formDrawerOpen, setFormDrawerOpen] = useState(false)
    const [subTaskDrawerOpen, setSubTaskDrawerOpen] = useState(false)

    useEffect(() => {
        reloadDomainCompanies()
    }, [])

    let schema = yup.object().shape({
        name: yup.string().required("Oppgavenavn er påkrevd"),
    });


    const formik = useFormik({
        initialValues: {
            name: template ? template.display_name : '',
            priority: false,
            signature: 1,
            interval: template ? template.deadline : {
                repetition: 1,
                startDate: null,
                endDate: null
            },
            description: template ? template.description : null,
            responsibleUsers: [],
            responsibleCompanies: [],
            files: template ? template.attachments : []
        },
        validationSchema: schema,
        onSubmit: async (values) => {  
            console.log(values)
            saveTask(values)
        },
    });

    const saveTask = (data) => {
        createTask({
            name: data.name,
            files: data.files,
            description: data.description,
            interval: data.interval,
            signature: data.signature,
            priority: data.priority,
            responsibleUsers: data.responsibleUsers,
            responsibleCompanies:data.responsibleCompanies,
            form: form,
            subtasks: subtasks
        })
    }
    return (
        <div className="p-md-3 p-2">
            <div className="box p-md-4 p-3">
                <h3 className="bold mb-md-5 mb-2">Opprett oppgave</h3>
                <hr/>
                <div className="row gx-1 mb-3">
                    <div className="col-auto mb-1">
                        <div onClick={() => setFormDrawerOpen(true)} className="border p-3 pointer" style={{borderRadius: '5px'}}>
                            <div className="row gx-md-3 gx-2 align-items-center">
                                <div className="col-auto">
                                    <FontAwesomeIcon className={Object.keys(form).length ? "text-primary" : ""} size='2x' icon={['fal', 'clipboard']} />
                                </div>
                                <div className="col">
                                    <h6 className='bold m-0'>Skjema</h6>
                                    
                                    {
                                        Object.keys(form).length ? <i>Rediger skjema</i>
                                        : <i className="hint-text">Legg til skjema</i>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-auto">
                        <div onClick={() => setSubTaskDrawerOpen(true)} className="border p-3 pointer" style={{borderRadius: '5px'}}>
                            <div className="row gx-md-3 gx-2 align-items-center">
                                <div className="col-auto">
                                    <FontAwesomeIcon className={subtasks && subtasks.length ? "text-primary" : ""} size='2x' icon={['fal', 'network-wired']} />
                                </div>
                                <div className="col">
                                    <h6 className='bold m-0'>Underoppgaver</h6>
                                    {
                                        subtasks && subtasks.length ? <i>{subtasks.length} underoppgaver</i>
                                        : <i className="hint-text">Legg til</i>
                                    }
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <form onSubmit={formik.handleSubmit}>
                <div className="row">
                    <div className="col-lg-8">
                        <Input
                            name="name"
                            label="Navn"
                            type="text"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            touched={formik.touched.name}
                            helperText={formik.touched.name && formik.errors.name}
                            placeholder={"Navn på oppgave"}
                        />
                        <div className="form-group mb-3">
                            <label>Beskrivelse</label>
                            <DraftWysiwyg
                                value={formik.values.description}
                                setValue={(e) => formik.setFieldValue('description', e)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Vedlegg</label>
                            <FileUpload
                                files={formik.values.files}
                                setFiles={(e) => formik.setFieldValue('files', e)}
                            />
                        </div>
                    </div>
                    
                    <div className="col">
                        <div className="form-group mb-3">
                            <label>Velg ansvarlig</label>
                            <div className="row gx-2">
                                <div className="col-auto">
                                    <div className={"icon-check-container"} >
                                        <div className="row gx-2">
                                            <div className="col-auto">
                                                <button type="button" className={"icon-check-button"} onClick={() => setPersonModalOpen(true)}>
                                                    <FontAwesomeIcon icon={['fal', 'plus']} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    formik.values.responsibleUsers.length > 0 && formik.values.responsibleUsers.map((el, key) => {
                                        return (
                                            <div key={key} className="col-auto">
                                                <UserPhoto photo={el.photo} name={el.fullname} size={[40, 40, 40]} />
                                            </div>
                                        )
                                    })
                                }
                                {
                                    formik.values.responsibleCompanies.length > 0 && formik.values.responsibleCompanies.map((el, key) => {
                                        return (
                                            <div key={key} className="col-auto">
                                                <UserPhoto photo={el.image} name={el.name} size={[40, 40, 40]} />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            
                            
                        </div>
                        <div className="form-group mb-3">
                            <label>Signering</label>
                            <RadioGroup
                                items={[
                                    {label: 'Ingen signering', value: 1},
                                    {label: 'Krev signatur av ansvarlige', value: 2},
                                ]}
                                selected={formik.values.signature}
                                select={(e) => formik.setFieldValue('signature', e)}
                            />
                        </div>
                        <div className="form-group mb-3">
                            <label>Prioritet</label>
                            <IconCheck
                                checked={formik.values.priority}
                                setChecked={(e) => formik.setFieldValue('priority', e)}
                                icon="flag"
                                color="danger"
                                classes="mb-2"
                            />
                            <p><i>{ formik.values.priority ? 'Oppgaven er merket som prioritert' : 'Oppgaven har ingen spesiell prioritet'} </i></p>
                        </div>
                        <TaskRepetition 
                            value={formik.values.interval}
                            setValue={(e) => formik.setFieldValue('interval', e)}
                        />
                    </div>
                </div>
                <div className="row mt-5 justify-content-center">
                    
                    <div className="col-md-5 col">
                        <div className="d-grid">
                            <button type="submit" className="btn btn-primary d-block">Lagre oppgave</button>
                        </div>
                    </div>
                </div>
                </form>
                <Drawer open={formDrawerOpen} setOpen={setFormDrawerOpen} >
                    <FormBuilderProvider currentContext={Context} />     
                </Drawer>
                <Drawer open={subTaskDrawerOpen} setOpen={setSubTaskDrawerOpen}>
                    <SubtaskProvider TaskContext={Context} />        
                </Drawer>
                <Drawer open={personModalOpen} setOpen={setPersonModalOpen}>
                    <PersonModal 
                        users={domainUsers}
                        companies={domainCompanies}
                        responsibleCompanies={formik.values.responsibleCompanies}
                        responsibleUsers={formik.values.responsibleUsers}
                        setResponsibleCompanies={(e) => formik.setFieldValue('responsibleCompanies', e)}
                        setResponsibleUsers={(e) => formik.setFieldValue('responsibleUsers', e)}
                        setOpen={setPersonModalOpen}
                    />
                </Drawer>
            </div>
        </div>
    )
    
}



